import { createContext } from "react";
import noop from "lodash/fp/noop";

export default createContext({
  isOpen: false,
  toggleOpen: noop,
  open: noop,
  close: noop,
});
